import { render, staticRenderFns } from "./DispatchAction.vue?vue&type=template&id=56887136&scoped=true&"
import script from "./DispatchAction.vue?vue&type=script&lang=js&"
export * from "./DispatchAction.vue?vue&type=script&lang=js&"
import style0 from "./DispatchAction.vue?vue&type=style&index=0&id=56887136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56887136",
  null
  
)

export default component.exports